<template>
  <div id="bank-accounts-access-modal_ayandeh" class="modal fade" role="dialog">
    <div class="modal-dialog" style="max-width: 700px">
      <!-- Modal content-->
      <div class="modal-content" id="bank-accounts-access-modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            {{ $t('label.manage_bank_accounts_access') }}
          </h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <form id="bank_accounts_access_form_ayandeh">
            <kt-row class="mb-3">
              <!--Account Number-->
              <kt-col lg="6" md="6" xs="12">
                <label class="col-form-label" for="account_number">
                  {{ $t('label.account_number') }}
                </label>
                <input
                    dir="ltr"
                    type="text"
                    class="form-control en_num"
                    id="account_number"
                    name="account_number"
                    v-model="bank_accounts_access.account_number"
                >
              </kt-col>
              <!--Status-->
              <kt-col lg="6" md="6" xs="12">
                <label class="col-form-label" for="status">
                  {{ $t('label.status') }}
                </label>
                <select id="status"
                        name="status"
                        class="form-control kt-selectpicker"
                        v-model="bank_accounts_access.status"
                >
                  <option :value="1" v-text="$t('label.pending')"></option>
                  <option :value="2" v-text="$t('label.active')"></option>
                  <option :value="3" v-text="$t('label.rejected')"></option>
                </select>
              </kt-col>
            </kt-row>
            <!--Button-->
            <kt-form-action class="mt-4">
              <kt-button
                  class="m-2 btn-wide"
                  size="lg"
                  variant="success"
                  type="button"
                  v-bind:wide="true"
                  id="store_bank_accounts_access_btn"
                  @click="storeBankAccountsAccess()"
              >
                {{ $t('btn.edit') }}
              </kt-button>
            </kt-form-action>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AyandeBankAccountsAccessModal",
  props: {
    bank_accounts_access:{
      required: true
    }
  },
  methods: {
    storeBankAccountsAccess() {
        this.bank_accounts_access.username= '';
        this.bank_accounts_access.password= '';
      this.$emit('storeBankAccountsAccess', this.bank_accounts_access)
    }
  }
}
</script>

<style scoped>

</style>